import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { SmCheckboxModel } from 'common/models/utility-models/meta-model';


import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AssignmentFormWidgetService } from 'common/widget/assignment/assignment-form-widget.service';




@Injectable({
    providedIn: 'root'
})
export class AssignmentFormResolver extends FormResolverService<AssignmentModel> {
    constructor(
        protected fs: AssignmentFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
        
    }
    override modifyResponseData(dataModel) {
        const zoneNames = this.systemService.dataStorage.zone_name;
        for (const zone of zoneNames) {
            dataModel[zone.zone_name] = '';
        }
        return dataModel;
    }

    override getMetaForComponent() {
        const meta = this.pageService.getMetaModel();
        const zoneNames = this.systemService.dataStorage.zone_name;
        const directionCheckboxes = {};
        for (const zone of zoneNames) {
            directionCheckboxes[zone.zone_name] = new SmCheckboxModel(
                zone.zone_name,
                zone.zone_name,
                'checkbox',
                false,
                'col-6 col-md-1',
                1,
                8,
                zone.zone_name.charAt(0).toUpperCase() + zone.zone_name.slice(1),
                'checkbox',
                '',
                false,
                true,
                true,
                false,
                0,
                0,
                false,
                false   
            );
        }
        meta.properties = {
            ...meta.properties,
            ...directionCheckboxes
        };
        return meta;
    }

}
